module.exports = __webpack_public_path__ + "media/flags/ke-7b6e16f1.svg";